import { render, staticRenderFns } from "./CoverageReportSearch.vue?vue&type=template&id=62706347&scoped=true"
import script from "./CoverageReportSearch.vue?vue&type=script&lang=js"
export * from "./CoverageReportSearch.vue?vue&type=script&lang=js"
import style0 from "./CoverageReportSearch.vue?vue&type=style&index=0&id=62706347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62706347",
  null
  
)

export default component.exports